import { ModuleLoadingProvider } from './module-loading.provider';
import angular = require('angular');
import { ModuleLoaderDirective } from './module-loader.directive';

export const angularModuleLoadingModule = 'angularModuleLoadingModule';

const module = angular.module(angularModuleLoadingModule, []);

module.provider('moduleLoading', ModuleLoadingProvider);
module.directive('dModuleLoader', ModuleLoaderDirective);
